import React from 'react';
import { LOCKED_PORTFOLIO_EXITS_IMAGE } from '../mockImages';

const LockedPortfolioExitsSection = () => (
    <div
        className="structured-investments-table-shell structured-investments-table-shell--locked"
        aria-hidden="true"
    >
        <div className="structured-investments-table-wrapper structured-investments-table-wrapper--locked">
            <img
                src={LOCKED_PORTFOLIO_EXITS_IMAGE}
                alt="Locked portfolio exits preview"
                className="structured-investments-table__preview-image structured-investments-table__preview-image--portfolio-exits"
            />
        </div>
    </div>
);

export default LockedPortfolioExitsSection;
